<template>
    <template v-if="page">
        <div class="min-h-dvh banner tw-relative tw-flex tw-flex-col tw-overflow-hidden">
            <div class="arc-gallery tw-relative tw-left-1/2 tw-z-20 tw-mt-10 -tw-translate-x-1/2">
                <div class="tw-flex tw-justify-between">
                    <div
                        v-for="(card, i) in cards"
                        :key="card.id"
                        class="arc-img tw-flex tw-h-[320px] tw-w-[260px] tw-flex-col tw-justify-between tw-rounded-4xl tw-bg-white tw-text-left"
                        :class="card.image ? '' : 'tw-p-8'"
                        :style="`--i: ${i}`">
                        <img
                            v-if="card.image"
                            alt=""
                            class="tw-h-full tw-w-full tw-object-cover"
                            :src="useMedia(card.image).small" />
                        <template v-else>
                            <p
                                class="tw-text-2xl"
                                v-html="card.topText"></p>
                            <p v-html="card.bottomText"></p>
                        </template>
                    </div>
                </div>
            </div>

            <div class="io-container tw-relative tw-z-20 tw-my-0 tw-flex tw-flex-grow tw-flex-col tw-items-center tw-justify-start tw-py-8 tw-pb-0 tw-text-center 3xl:tw-pt-16">
                <Tag
                    color="ioacademy"
                    :text="page.name" />
                <h1
                    class="tw-mt-10"
                    v-html="page.title"></h1>
                <h3
                    class="tw-mt-6"
                    v-html="page.subTitle"></h3>
            </div>
        </div>
        <section class="io-container radial-grad tw-z-20">
            <div class="tw-grid tw-grid-cols-1 tw-gap-10 xl:tw-grid-cols-12">
                <div class="xl:tw-col-span-6">
                    <img
                        v-if="page.aboutImage"
                        alt=""
                        class="tw-mx-auto tw-h-full tw-max-h-[300px] tw-object-cover md:tw-max-h-[500px] xl:tw-max-h-[600px]"
                        :src="useMedia(page.aboutImage).original" />
                </div>
                <div class="xl:tw-col-span-6">
                    <h2
                        class=""
                        v-html="page.aboutTitle"></h2>
                    <h3
                        class="ckeditor tw-mb-4"
                        v-html="page.aboutText"></h3>
                    <v-btn
                        class="tw-mb-16 tw-h-12 md:tw-h-14 md:tw-px-7 xl:tw-text-base"
                        color="primary"
                        flat
                        height="46"
                        rounded="pill"
                        @click="scrollToSendCV">
                        {{ $t('ioacademy.sendCV') }}
                    </v-btn>
                </div>
            </div>
        </section>
        <section class="io-container">
            <h2 v-html="page.offerTitle"></h2>
            <h3 v-html="page.offerText"></h3>
            <div class="tw-mt-8 tw-grid tw-gap-5 sm:tw-grid-cols-2 xl:tw-grid-cols-4 3xl:tw-mt-16 3xl:tw-gap-10">
                <div
                    v-for="offer in offers"
                    :key="offer.id"
                    class="ioacademy-offer tw-flex tw-flex-col tw-items-start tw-rounded-4xl tw-px-10 tw-py-8 3xl:tw-p-10">
                    <img
                        alt=""
                        class="tw-h-14 tw-w-14 tw-object-contain md:tw-h-16 md:tw-w-16"
                        :src="useMedia(offer.icon).small" />
                    <h3
                        class="tw-mb-2 tw-mt-4 tw-text-lg tw-font-semibold 3xl:tw-text-xl"
                        v-html="offer.name"></h3>
                    <ul>
                        <li
                            v-for="item in offer.points"
                            class="tw-my-3 tw-flex tw-items-start tw-gap-1 tw-font-light max-md:tw-text-sm">
                            <v-icon :color="offer.color">mdi-check-circle</v-icon> {{ item.name }}
                        </li>
                    </ul>
                </div>
            </div>
        </section>
        <section class="io-container">
            <h2
                class="tw-text-center"
                v-html="page.areasTitle"></h2>
            <div class="tw-grid tw-gap-4 md:tw-grid-cols-2 xl:tw-gap-x-9 xl:tw-gap-y-7">
                <div
                    v-for="area in areas"
                    :key="area.id"
                    class="ioacademy-area tw-flex tw-items-center tw-justify-between tw-gap-6 tw-rounded-4xl tw-py-10 tw-pl-8 tw-pr-6 xl:tw-gap-10 xl:tw-pl-20 xl:tw-pr-14">
                    <h3
                        class="tw-text-lg tw-font-semibold tw-text-white xl:tw-text-xl"
                        v-html="area.name"></h3>
                    <img
                        alt=""
                        class="tw-h-14 tw-w-14 tw-object-contain md:tw-h-16 md:tw-w-16 2xl:tw-h-20 2xl:tw-w-20"
                        :src="useMedia(area.icon).small" />
                </div>
            </div>
        </section>
        <section class="io-container radial-grad">
            <div class="tw-z-50 tw-grid tw-grid-cols-1 tw-gap-10 lg:tw-grid-cols-12">
                <div class="lg:tw-col-span-6">
                    <h2
                        class=""
                        v-html="page.admissionTitle"></h2>
                    <h3
                        class="ckeditor tw-mb-4"
                        v-html="page.admissionText"></h3>
                </div>
                <div class="lg:tw-col-span-6">
                    <img
                        v-if="page.admissionImage"
                        alt=""
                        class="tw-mx-auto tw-h-full tw-max-h-[300px] tw-object-contain md:tw-max-h-[500px] xl:tw-max-h-[600px]"
                        :src="useMedia(page.admissionImage).original" />
                </div>
            </div>
        </section>
        <section class="io-container">
            <h2 v-html="page.studentsTitle"></h2>
            <h3
                class="tw-mb-10"
                v-html="page.studentsText"></h3>
            <TestemoniesStudentsSlider :content="studentTestimonies" />
        </section>
        <section
            id="send-cv"
            class="grad-ioacademy-form">
            <div class="io-container tw-relative tw-z-20 tw-my-0 tw-flex tw-flex-grow tw-flex-col tw-items-start tw-justify-start tw-pb-24 tw-pt-8 tw-text-center 3xl:tw-pt-16">
                <h1
                    class="tw-mt-10 tw-text-left tw-font-bold"
                    v-html="page.interestedTitle"></h1>
                <v-form
                    ref="form"
                    class="tw-mt-14 tw-w-full"
                    @submit.prevent="onFormSubmit">
                    <div class="tw-grid tw-grid-cols-1 tw-gap-x-8 tw-gap-y-6 md:tw-grid-cols-2 lg:tw-gap-x-16">
                        <div class="tw-grow tw-text-left">
                            <v-label class="tw-mb-3 tw-text-lg tw-text-dark tw-opacity-100">{{ $t('ioacademy.name') }}*</v-label>
                            <v-text-field
                                v-model.trim="name"
                                flat
                                name="name"
                                :placeholder="$t('ioacademy.namePlaceholder')"
                                :rules="[$rules.required]"
                                variant="solo"></v-text-field>
                        </div>
                        <div class="tw-grow tw-text-left">
                            <v-label class="tw-mb-3 tw-text-lg tw-text-dark tw-opacity-100">{{ $t('ioacademy.email') }}*</v-label>
                            <v-text-field
                                v-model.trim="email"
                                flat
                                name="email"
                                :placeholder="$t('ioacademy.emailPlaceholder')"
                                :rules="[$rules.required, $rules.email]"
                                type="email"
                                variant="solo"></v-text-field>
                        </div>
                        <div class="tw-grow tw-text-left">
                            <v-label class="tw-mb-3 tw-text-lg tw-text-dark tw-opacity-100">{{ $t('ioacademy.course') }}</v-label>
                            <v-text-field
                                v-model.trim="course"
                                flat
                                name="course"
                                :placeholder="$t('ioacademy.coursePlaceholder')"
                                variant="solo"></v-text-field>
                        </div>
                        <div class="tw-grow tw-text-left">
                            <v-label class="tw-mb-3 tw-text-lg tw-text-dark tw-opacity-100">{{ $t('ioacademy.interestArea') }}</v-label>
                            <!-- v-select with open positions -->
                            <v-select
                                v-model="selectedArea"
                                clearable
                                density="comfortable"
                                elevation="0"
                                flat
                                hide-details="auto"
                                item-title="name"
                                item-value="documentId"
                                :items="areas"
                                :placeholder="$t('ioacademy.interestAreaPlaceholder')"
                                return-object
                                rounded="pill"
                                variant="solo"></v-select>
                        </div>
                    </div>
                    <div class="tw-mt-6 tw-w-full tw-text-left">
                        <v-label class="tw-mb-3 tw-text-lg tw-text-dark tw-opacity-100">{{ $t('ioacademy.cv') }}</v-label>
                        <template v-if="!cv">
                            <v-file-upload
                                v-model="cv"
                                border="0"
                                class="tw-rounded-3xl"
                                clearable
                                color="white"
                                density="compact"
                                @update:model-value="onCvSet">
                                <template #icon>
                                    <v-icon
                                        color="blue-55"
                                        icon="mdi-file-document"></v-icon>
                                </template>
                                <template #title>
                                    <p class="tw-text-xs tw-font-light tw-text-gray-700" v-html="$t('ioacademy.cvInstructions')"></p>
                                </template>
                            </v-file-upload>
                            <p
                                v-if="fileTooBig"
                                class="tw-mt-2 tw-text-xs tw-font-normal tw-text-red">
                                {{ $t('ioacademy.fileTooBig') }}
                            </p>
                        </template>
                        <div
                            v-else
                            class="tw-flex tw-w-full tw-items-center tw-justify-center tw-rounded-3xl tw-bg-white tw-bg-opacity-50 tw-p-4">
                            <span class="tw-text-xs tw-font-light tw-text-gray-700">{{ $t('ioacademy.selectedFile') }}: {{ cv?.name }}</span>
                            <v-btn
                                class="tw-text-lg tw-font-semibold"
                                color="dark"
                                elevation="0"
                                rounded="pill"
                                variant="text"
                                @click="cv = undefined">
                                <v-icon
                                    class="tw-ml-2"
                                    color="blue"
                                    icon="mdi-delete"></v-icon>
                            </v-btn>
                        </div>
                    </div>
                    <div class="tw-mt-6 tw-w-full tw-text-left">
                        <v-label class="tw-mb-3 tw-text-lg tw-text-dark tw-opacity-100">{{ $t('ioacademy.message') }}*</v-label>
                        <v-textarea
                            v-model.trim="message"
                            class="message-area"
                            flat
                            hide-details="auto"
                            :placeholder="$t('ioacademy.messagePlaceholder')"
                            :rules="[$rules.required]"
                            variant="solo"></v-textarea>
                    </div>
                    <div class="tw-mt-8 tw-text-right">
                        <p
                            v-if="response"
                            class="tw-mb-3 tw-text-lg"
                            :class="responseType === 'success' ? 'tw-text-green' : 'tw-text-red'">
                            {{ response }}
                        </p>
                        <v-btn
                            v-if="!response || (response && responseType === 'error')"
                            class="tw-px-8"
                            color="primary"
                            elevation="0"
                            height="50"
                            :loading="isLoading"
                            rounded="pill"
                            type="submit">
                            {{ $t('ioacademy.send') }}
                        </v-btn>
                    </div>
                </v-form>
            </div>
        </section>
    </template>
    <template v-else>
        <!-- loader -->
        <Loader />
    </template>
</template>

<script setup lang="ts">
    import { createioAcademyContact } from '@/api/contacts';
    import { uploadFiles } from '@/api/upload';
    import useRules from '@/composables/rules';
    import { useMedia } from '@/composables/useMedia';
    import { useAppStore } from '@/store/app';
    import { useMounted } from '@vueuse/core';
    import { useI18n } from 'vue-i18n';

    const { t } = useI18n();
    const appStore = useAppStore();
    const isMounted = useMounted();
    const $rules = useRules();

    const name = ref('');
    const email = ref('');
    const course = ref('');
    const cv = ref<File | File[] | undefined>(undefined);

    const fileTooBig = ref(false);
    const message = ref('');
    const response = ref('');
    const responseType = ref<'success' | 'error'>('error');
    const isLoading = ref(false);
    const form = ref();
    const selectedArea = ref(null);

    const page = computed(() => {
        return appStore.getIOAcademy;
    });

    const cards = computed(() => {
        return page.value.slider;
    });

    const offers = computed(() => {
        return page.value.offers;
    });

    const areas = computed(() => {
        return page.value.areas;
    });

    const studentTestimonies = computed(() => {
        return appStore.getStudentTestimonies;
    });

    function onCvSet(files: File | File[]) {
        if (isFileTooBig(files)) {
            fileTooBig.value = true;
            cv.value = undefined;
            return;
        }
        fileTooBig.value = false;
        cv.value = files;
    }

    function isFileTooBig(file: File | File[] | undefined) {
        if (!file) return false;
        return Array.isArray(file) ? file.some((f) => f.size > 10 * 1024 * 1024) : file.size > 10 * 1024 * 1024;
    }

    watchEffect(() => {
        if (isMounted.value && page.value) {
            document.documentElement.style.setProperty('--page-color', `rgb(var(--v-theme-ioacademy))`);
        }
    });

    function scrollToSendCV() {
        // scroll onto the #send-cv, but add a offset y
        const element = document.getElementById('send-cv');
        if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
        }
    }

    async function onFormSubmit() {
        if (!form.value) return;
        form.value.resetValidation();
        response.value = '';
        const { valid } = await form.value.validate();
        if (!valid) return;
        isLoading.value = true;
        try {
            const { data } = await uploadFiles({
                files: cv.value as File,
            });

            await createioAcademyContact({
                name: name.value,
                email: email.value,
                course: course.value,
                message: message.value,
                file: data[0].id,
                area: !selectedArea.value ? undefined : selectedArea.value.documentId,
            });
            response.value = t('ioacademy.successMessage');
            responseType.value = 'success';
            cv.value = undefined;
            selectedArea.value = null;
            form.value.reset();
        } catch (error) {
            console.error(error);
            response.value = t('ioacademy.errorMessage');
            responseType.value = 'error';
        } finally {
            isLoading.value = false;
        }
    }

    watchEffect(() => {
        if (page.value?.name) {
            document.title = page.value?.name + ' - IOTech';
        }
    });
</script>

<style scoped>
    #send-cv {
        scroll-margin-top: 100px;
    }

    .banner::after {
        content: '';
        position: absolute;
        inset: 0;
        background: transparent linear-gradient(180deg, rgb(var(--v-theme-ioacademy)) 0%, #80808000 100%) 0% 0% no-repeat padding-box;
        opacity: 0.1;
    }

    .arc-gallery {
        width: max(110%, 2110px);
    }

    .arc-img {
        /* box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1); */
        overflow: hidden;
        /* transform-style: preserve-3d; */
        /* transition: transform 0.3s ease; */
    }

    .arc-img:nth-of-type(1) {
        transform: translate(20%, 120%) rotate(-48deg);
    }
    .arc-img:nth-of-type(2) {
        transform: translate(0%, 55%) rotate(-32deg);
    }
    .arc-img:nth-of-type(3) {
        transform: translate(-5%, 12%) rotate(-16deg);
    }
    .arc-img:nth-of-type(4) {
        /* transform: translateY(100%) rotate(-45deg) ; */
    }
    .arc-img:nth-of-type(5) {
        transform: translate(5%, 12%) rotate(16deg);
    }
    .arc-img:nth-of-type(6) {
        transform: translate(0%, 55%) rotate(32deg);
    }
    .arc-img:nth-of-type(7) {
        transform: translate(-20%, 120%) rotate(48deg);
    }

    .ioacademy-offer {
        background: rgb(var(--v-theme-gray-40)) url('@/assets/gradients/gradient-ioacademy-offers.png');
        background-position: center center;
        background-size: cover;
        background-repeat: no-repeat;
    }
    .ioacademy-area {
        background: rgb(var(--v-theme-ioacademy)) url('@/assets/gradients/gradient-ioacademy-areas.png');
        background-position: center center;
        background-size: cover;
        background-repeat: no-repeat;
    }
</style>
